const formatEpisodes = function formatTAGEpisodesForFeed(items) {
  return items.map(item => ({
    header: item.title,
    as: 'a',
    meta: item.date_formatted,
    href: `https://www.twr360.org/programs/view/id,${item.id}`,
    description: item.description,
  }));
};

export default formatEpisodes;



// WEBPACK FOOTER //
// ./src/components/formatEpisodes.js